import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/shared/ui/moleculas/accordion/ui.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/layout/footer/ui.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/widgets/layout/header/ui.tsx");
